/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths, APIDataProvider, TApiResponse } from '../../../api';
import { IFlexiblePlan } from '.';

const apiDataProvider = new APIDataProvider();

export const getUserFlexiblePlans = createAsyncThunk(
  '/flexible-plans/list',
  async (userId?: string) => {
    let path = `${ApiPaths.flexiblePlans}`;

    if (userId) {
      const queryParams = new URLSearchParams({ userId });
      path += `?${queryParams.toString()}`;
    }

    const response = await apiDataProvider.get<TApiResponse<IFlexiblePlan[]>>(
      path
    );

    return response.data;
  }
);
